export const About = (props) => {
	return (
		<div id="about">
			<div className="container">
				<div className="row">
					<div className="col-xs-12 col-md-6">
						{" "}
						<img
							src="https://firebasestorage.googleapis.com/v0/b/team-ao-xanh.appspot.com/o/images%2Faboutas.jpg?alt=media&token=df5016bc-c1c5-42f8-a310-86a6055eff4b"
							className="img-responsive"
							alt=""
						/>{" "}
					</div>
					<div className="col-xs-12 col-md-6">
						<div className="about-text">
							<h2>Về chúng tôi</h2>
							<p>{props.data ? props.data.paragraph : "loading..."}</p>
							{/* <h3>Tại sao chúng tôi làm điều này!</h3> */}
							{/* <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div> */}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
